<template>
  <ion-page style="overflow: auto;">
    <fis-header></fis-header>
    <div class="content visible-box">
      <div class="container-fluid" id="itenary-div">
        <div class="row">
          <div class="col-sm-12" id="top-margin"></div>
        </div>
        <div class="row">
          <div class="col-sm-12" id="top-margin"></div>
        </div>

        <!-- /*Smart Planner*/ -->
        <div class="row">
          <div class="col-sm-12 text-center">
            <div id="breadcrums" style="color:#34aade !important">
              <h2>Smart Planner</h2>
            </div>
            <div id="tagline">
              <p>Easy to find... Simple to use</p>
            </div>
          </div>
        </div>
        <br>

        <div class="row">
          <div class="col-sm-12 col-md-10 col-lg-9 col-xl-9" id="sm-left-div"
               style="margin-top:3% !important; padding-left:50px;">

            <div class="container">
              <div v-for="(cards, cardIndex) in information" :key="cardIndex" class="row" id="small-itenary">
                <div v-for="(info, index) in cards" :key="index" class="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                  <div class="row" id="itenary-card" @click="moreInfo(cards, index)">
                    <div class="col-sm-12 col-md-10 col-lg-10 col-xl-10">
                      <div class="row">
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" id="card-img-itenary"
                             style="padding:0px !important;">

                          <div class="img-class">
                            <img :src="storageBaseUrl + '/' + info['images'][0]['image']" class="planner-images" id="img-class" alt="">
                          </div>

                        </div>
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" id="itenary-info">

                          <h2> {{info['name']}}</h2>
                          <div class="category-icons-row">
                            <img v-for="category in info['categories']" :key="category.id" :src="storageBaseUrl + '/' + category.black_path" :alt="category.name" :title="category.name">
                            <span class="planner-save-label">Save</span>
                            <label :for="'itenary-heart-' + info.id" class="custom-checkbox planner-heart" @click.stop>
                              <input type="checkbox" :id="'itenary-heart-' + info.id" @click.stop="removeFavourites(info.id, index, cardIndex, $event)" checked/>
                              <i class="fa fa-heart-o"></i>
                              <i class="fa fa-heart"></i>
                            </label>
                          </div>
                          <p id="capt-line">{{info['intro']}}</p>
                          <p v-if="formatPlannerAddress(info['address'])"><b>A:</b> {{ formatPlannerAddress(info['address']) }}</p>
                          <template v-if="!shouldHidePhone(info)">
                            <p v-if="info['formatted_phone']"><b>{{ isAustralianMobile(info['formatted_phone']) ? 'M' : 'P' }}:</b> {{ info['formatted_phone'] }}</p>
                            <p v-if="info['formatted_mobile'] && String(info['formatted_mobile']).length > 6"><b>M:</b>{{ info['formatted_mobile'] }}</p>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Transition name="nested">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" v-if="cards.show" >

                  <div class="row" id="detail-itenary">
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2" ></div>
                    <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8" id="card-img" style="padding: 0px !important;">
                      <div id="carouselExampleControls" class="carousel slide" style="width: 100%;">
                        <swiper :slidesPerView="slides"
                                :loop="smartCardInfo['images'] && smartCardInfo['images'].length > 3"
                                :navigation="true"
                                :class="{ 'few-slides': smartCardInfo['images'] && smartCardInfo['images'].length <= 3 }"
                                :modules="modules" id="search-swipe">
                          <swiper-slide v-for="image in smartCardInfo['images']" :key="image.id">
                            <div class="col padding-0"> <img class="planner-swiper-images" :src="storageBaseUrl + '/' + image['image']" ></div>
                          </swiper-slide>
                        </swiper>

                      </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2" ></div>
                    <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2" ></div>
                    <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8" id="smart-search-text" style="border-radius: 0px 0px 10px 10px !important; ">

                      <h2 > {{smartCardInfo['name']}} </h2>

                      <img v-for="icon in smartCardInfo['categories']" :key="icon.id" :src="storageBaseUrl + '/' + icon.black_path" :alt="icon.name" :title="icon.name" style="margin-right: 5px;">
                      <br>
                      <p id="capt-line"><em style="color:#bba756;">{{smartCardInfo['caption']}}</em></p>
                      <p id="display-desc">{{smartCardInfo['description']}}</p>
                      <p v-if="formatPlannerAddress(smartCardInfo['address'])"><b>A:</b> {{ formatPlannerAddress(smartCardInfo['address']) }}</p>
                      <p v-if="smartCardInfo['formatted_phone']"><b>{{ isAustralianMobile(smartCardInfo['formatted_phone']) ? 'M' : 'P' }}:</b> {{ smartCardInfo['formatted_phone'] }}</p>
                      <p v-if="smartCardInfo['formatted_mobile'] && String(smartCardInfo['formatted_mobile']).length > 6"><b>M:</b>{{ smartCardInfo['formatted_mobile'] }}</p>

                      <div style=" padding:10px; width:40px;"></div>
                    </div>
                  </div>
                </div >
                </Transition>
              </div>
            </div>
          </div>
          <div v-if="loaded" class="col-lg-3 col-xl-3" id="map-planner">
            <div v-if="mapError" class="map-error" style="padding: 20px; text-align: center; background: #f8f9fa; border: 1px solid #dee2e6; border-radius: 4px;">
              <p style="color: #dc3545; margin-bottom: 10px;"><strong>Map Error</strong></p>
              <p style="font-size: 0.9em; color: #6c757d;">{{ mapError }}</p>
              <p style="font-size: 0.8em; color: #6c757d; margin-top: 10px;">Please check Google Maps API key configuration.</p>
            </div>
            <GoogleMap
                v-else
                :key="markers.length"
                api-key="AIzaSyBdBeIG5lH6hcBakr4-_mI7t88XfkkVTr4"
                :center="centre"
                class="map"
                :zoom="mapZoom"
                @error="handleMapError"
            >
              <Marker 
                v-for="(m, index) in markers" 
                :key="`marker-${index}-${m.position.lat}-${m.position.lng}`" 
                :options="{ position: m.position, clickable: true, title: m.title || `Marker ${index + 1}` }"
                @click="zoomToMarker(m.position)"
              />
              <CustomControl position="TOP_LEFT" class="ml-lg-n1" style="padding: 10px;margin-left: -1.5rem!important;">
                <button class="btn btn-primary"  @click="startMapsDirection()">Road Trip</button>
              </CustomControl>
            </GoogleMap>
          </div>
        </div>
      </div>
      <fis-footer></fis-footer>
    </div>
  </ion-page>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import fisHeader from "@/components/fisHeader.vue";
import fisFooter from "@/components/fisFooter.vue";
import {IonPage} from "@ionic/vue";
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Navigation, Pagination} from "swiper";
import {Transition} from "vue";
import { GoogleMap, Marker, CustomControl } from "vue3-google-map";
import 'swiper/css';
import '@ionic/vue/css/ionic-swiper.css';
import "swiper/css/navigation";
import {mapActions, mapGetters} from "vuex";
import axios from "@/axios";
import { isAustralianMobile } from '@/utils/australianPhone';

export default defineComponent({
  name: "SmartPlanner",
  components: {Swiper, SwiperSlide, fisHeader, fisFooter, IonPage, GoogleMap, Marker, CustomControl, Transition},
  setup: function () {
    const sayHi = () => alert('Hi!')
    return {
      modules: [Pagination, Navigation],
      swiperOptions: {
        breakpoints: {
          390: {
            slidesPerView: 1
          },
          480: {
            slidesPerView: 2
          },
          1280: {
            slidesPerView: 3
          },
          1281: {
            slidesPerView: 3
          }

        }
      },
      sayHi
    };
  },
  computed: {
    ...mapGetters({
      getItenary: 'itenary/getItenary'
    })
  },
  methods: {
    ...mapActions({
      addToItenary: 'itenary/addToItenary',
      removeFromItenary: 'itenary/removeFromItenary'
    }),
    isAustralianMobile,
    shouldHidePhone(card: any) {
      if (!card) return false;
      if (card.client_id === 1) return true;
      if (card.packages && card.packages.some((p: any) => p.id === 48 || p.id === 49)) return true;
      return false;
    },
    formatPlannerAddress(addr: string | undefined | null) {
      if (!addr) return '';
      const s = String(addr);
      const i = s.indexOf('(');
      return (i > 0 ? s.substring(0, i) : s).trim();
    },
    async geocodeAddress(address: string): Promise<{lat: number, lng: number} | null> {
      try {
        // Use backend API endpoint to proxy geocoding (avoids CORS issues)
        const encodedAddress = encodeURIComponent(address);
        const response = await axios.get(`/geocode?address=${encodedAddress}`);
        
        // Backend returns {lat: number, lng: number}
        if(response.data && response.data.lat !== undefined && response.data.lng !== undefined) {
          const lat = parseFloat(response.data.lat);
          const lng = parseFloat(response.data.lng);
          if(!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
            console.log('✓ Geocoded address:', address, '→', { lat, lng });
            return { lat, lng };
          } else {
            console.warn('Invalid coordinates returned from geocoding:', response.data);
            return null;
          }
        } else {
          console.warn('Geocoding failed for address:', address, 'Response:', response.data);
          return null;
        }
      } catch (error: any) {
        console.error('Geocoding error for address:', address, error);
        if(error.response) {
          console.error('Error response:', error.response.status, error.response.data);
        }
        return null;
      }
    },
    handleMapError(error: any) {
      console.error('Google Maps Error:', error);
      if (error && error.message) {
        if (error.message.includes('RefererNotAllowedMapError')) {
          this.mapError = 'API key not authorized for this domain. Please add http://localhost:8100/* to your Google Cloud Console API key restrictions.';
        } else {
          this.mapError = error.message;
        }
      } else {
        this.mapError = 'Failed to load Google Maps. Please check your API key configuration.';
      }
    },
    async fetchIntroPanels() {
      const itenaryIds = JSON.parse(localStorage.getItem('itenaryIds') || '{}');
      console.log('Fetching panels for itenaryIds:', itenaryIds);
      const response = await axios.get("/smartcard/"+itenaryIds);
      console.log('API Response:', response.data);
      let chunk = 3;
      for (let i=0; i<response.data.info.length; i += chunk) {
         const chunkArr = response.data.info.slice(i, i+chunk);
         chunkArr['show'] = false;
         this.information.push(chunkArr);
      }
      console.log('Information array after chunking:', this.information);
      if(this.information.length > 0 && this.information[0].length > 0) {
        const firstItem = this.information[0][0];
        console.log('First item in first chunk:', firstItem);
        console.log('First item keys:', Object.keys(firstItem));
        
        // Check for coordinates in multiple ways
        let hasCoordinates = false;
        
        // Method 1: Check for separate latitude/longitude fields
        if(firstItem['latitude'] !== undefined && firstItem['longitude'] !== undefined) {
          const lat = parseFloat(firstItem['latitude']);
          const lng = parseFloat(firstItem['longitude']);
          if(!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
            this.latLongCentre = [lng.toString(), lat.toString()];
            hasCoordinates = true;
            console.log('Found coordinates from lat/lng fields:', this.latLongCentre);
          }
        }
        // Method 2: Check for lat/lng fields (alternative naming)
        else if(firstItem['lat'] !== undefined && firstItem['lng'] !== undefined) {
          const lat = parseFloat(firstItem['lat']);
          const lng = parseFloat(firstItem['lng']);
          if(!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
            this.latLongCentre = [lng.toString(), lat.toString()];
            hasCoordinates = true;
            console.log('Found coordinates from lat/lng fields (alt):', this.latLongCentre);
          }
        }
        // Method 3: Check if address contains coordinates in parentheses
        else if(firstItem['address']) {
          const addressStr = firstItem['address'];
          console.log('First address found:', addressStr);
          const coordIndex = addressStr.indexOf('(');
          if(coordIndex > -1) {
            this.latLongCentre = addressStr.slice(coordIndex).replace(/[{()}]/g, '').split(',');
            hasCoordinates = true;
            console.log('Found coordinates in address:', this.latLongCentre);
          }
        }
        
        // Method 4: Geocode the first address if no coordinates found
        if(!hasCoordinates && firstItem['address']) {
          console.log('Geocoding first address for center:', firstItem['address']);
          const coords = await this.geocodeAddress(firstItem['address']);
          if(coords) {
            this.latLongCentre = [coords.lng.toString(), coords.lat.toString()];
            hasCoordinates = true;
            console.log('Geocoded coordinates:', this.latLongCentre);
          }
        }
        
        if(hasCoordinates) {
          await this.setOtherMarkers(this.information);
          this.setCentre();
        } else {
          console.warn('No coordinates found, using default center');
          await this.setOtherMarkers(this.information);
          this.loaded = true;
        }
      } else {
        // No data available, use default center
        console.warn('No information data available');
        this.loaded = true;
      }
      if(this.getItenary!=itenaryIds) {
        itenaryIds.forEach((val) => {
          this.addToItenary(val)
        })
      }
    },
    moreInfo($arr, $id) {
      this.information.forEach((val) => {
        if( val !== $arr) {
          val.show = false;
        }
      });
      if( $arr[$id]['images'].length <= 3) {
        this.slides = $arr[$id]['images'].length
      } else {
        this.slides = 3
      }
      if(this.smartCardInfo['id'] == $arr[$id].id && $arr.show) {
        $arr.show = !$arr.show;
      } else {
        $arr.show = true
      }
      this.smartCardInfo = $arr[$id];
      console.log(this.smartCardInfo['id'], $arr[$id].id)
    },
    removeFavourites($id, arrIndex, informationIndex, event) {
      if(!event.target.checked) {
        console.log(localStorage.getItem('itenaryIds'))
        this.information[informationIndex].splice(arrIndex, 1);
        this.removeFromItenary($id);
        this.$router.go(0)
      }
    },
    setCentre() {
      if(this.latLongCentre && this.latLongCentre.length >= 2) {
        const lat = parseFloat(this.latLongCentre[1]);
        const lng = parseFloat(this.latLongCentre[0]);
        // Validate that parsed values are valid numbers
        if(!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
          this.centre = {
            lat: lat,
            lng: lng
          };
        } else {
          // Invalid coordinates, keep default center from setup()
          console.warn('Invalid coordinates parsed, using default center');
        }
      } else {
        // No coordinates available, keep default center from setup()
        console.warn('No coordinates available, using default center');
      }
      this.loaded=true;
    },
    async setOtherMarkers(information) {
      this.markers = []; // Reset markers array
      console.log('setOtherMarkers called with information:', information);
      
      // Process all items and collect addresses that need geocoding
      const itemsToGeocode: Array<{data: any, index: number}> = [];
      
      information.forEach((val, valIndex) =>{
        val.forEach((data, dataIndex)=>{
          console.log(`Processing item ${dataIndex} in chunk ${valIndex}:`, data);
          
          let lat: number | null = null;
          let lng: number | null = null;
          
          // Method 1: Check for separate latitude/longitude fields
          if(data['latitude'] !== undefined && data['longitude'] !== undefined) {
            lat = parseFloat(data['latitude']);
            lng = parseFloat(data['longitude']);
            console.log('Found lat/lng fields:', { lat, lng });
          }
          // Method 2: Check for lat/lng fields (alternative naming)
          else if(data['lat'] !== undefined && data['lng'] !== undefined) {
            lat = parseFloat(data['lat']);
            lng = parseFloat(data['lng']);
            console.log('Found lat/lng fields (alt):', { lat, lng });
          }
          // Method 3: Check if address contains coordinates in parentheses
          else if(data['address']) {
            const addressStr = data['address'];
            console.log('Checking address for coordinates:', addressStr);
            const coordIndex = addressStr.indexOf('(');
            if(coordIndex > -1) {
              // Extract coordinates: format is "Address (lng, lat)"
              const coordStr = addressStr.slice(coordIndex).replace(/[{()}]/g, '').trim();
              const location = coordStr.split(',').map(s => s.trim());
              if(location.length >= 2) {
                lng = parseFloat(location[0]);
                lat = parseFloat(location[1]);
                console.log('Extracted coordinates from address:', { lat, lng });
              }
            }
          }
          
          // Add marker if we have valid coordinates
          if(lat !== null && lng !== null && !isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
            const marker = {
              position: { lat: lat, lng: lng },
              title: data['name'] || data['address'] || `Location ${dataIndex + 1}`
            };
            this.markers.push(marker);
            console.log('✓ Added marker:', marker);
          } else if(data['address']) {
            // Need to geocode this address
            itemsToGeocode.push({ data, index: this.markers.length });
            console.log('Queued for geocoding:', data['address']);
          } else {
            console.warn('✗ No valid coordinates or address found for item:', data);
          }
        })
      });
      
      // Geocode addresses that need it (with delay to avoid rate limits)
      if(itemsToGeocode.length > 0) {
        console.log(`Geocoding ${itemsToGeocode.length} addresses...`);
        for(let i = 0; i < itemsToGeocode.length; i++) {
          const item = itemsToGeocode[i];
          const coords = await this.geocodeAddress(item.data['address']);
          if(coords) {
            const marker = {
              position: { lat: coords.lat, lng: coords.lng },
              title: item.data['name'] || item.data['address'] || `Location ${i + 1}`
            };
            // Use Vue's reactivity by directly assigning to array
            this.markers.push(marker);
            console.log(`✓ Geocoded and added marker ${i+1}/${itemsToGeocode.length}:`, marker);
            console.log('Current markers array:', JSON.stringify(this.markers));
          }
          // Add small delay between requests to avoid rate limiting (100ms delay)
          if(i < itemsToGeocode.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 100));
          }
        }
      }
      
      console.log('Total markers created:', this.markers.length);
      console.log('Markers array:', JSON.stringify(this.markers, null, 2));
      console.log('Markers for map:', this.markers.map(m => ({ lat: m.position.lat, lng: m.position.lng })));
      
      // Force Vue to detect the change
      this.$nextTick(() => {
        this.$forceUpdate();
        console.log('Map should update with', this.markers.length, 'markers');
      });
    },
    getMarkerOptions(marker: any, index: number) {
      return {
        position: marker.position,
        clickable: true,
        title: marker.title || `Marker ${index + 1}`,
        // Add click handler via options
        onClick: () => {
          this.zoomToMarker(marker.position);
        }
      };
    },
    zoomToMarker(position: {lat: number, lng: number}) {
      // Zoom in to the clicked marker
      this.centre = position;
      this.mapZoom = 15; // Zoom level for close-up view
      console.log('Zooming to marker:', position);
    },
    startMapsDirection() {
      if(!this.markers || this.markers.length === 0) {
        console.warn('No markers available for directions');
        return;
      }
      let waypoints;
      let destination;
      this.markers.forEach((val, index)=>{
        if(val && val['position'] && val['position']['lat'] && val['position']['lng']) {
          if(index == (this.markers.length-1)) {
            destination = val['position']['lat']+','+ val['position']['lng']
          }
          if(index == 0) {
            waypoints = val['position']['lat'] + ',' + val['position']['lng']
          } else {
            waypoints = waypoints + '|' + val['position']['lat'] + ',' + val['position']['lng']
          }
        }
      });
      if(destination && waypoints) {
        let url = "https://www.google.com/maps/dir/?api=1&destination="+destination+"&waypoints="+waypoints;
        window.open(url, '_blank', 'noreferrer');
      } else {
        console.warn('Invalid marker data for directions');
      }
    }
  },
  created() {
    this.fetchIntroPanels()
    this.smartCardInfo['name'] = null
    this.smartCardInfo['categories'] = []
    this.smartCardInfo['images'] = []
    this.smartCardInfo['caption'] = null
    this.smartCardInfo['description'] = null
    this.smartCardInfo['address'] = null
    this.smartCardInfo['formatted_phone'] = null
    this.smartCardInfo['formatted_mobile'] = null
  },
  data() {
    return {
      storageBaseUrl: `${(process.env.VUE_APP_API_BASE_URL || '').replace(/\/+$/, '')}/storage`,
      loaded: false,
      images: [] as Array<any>,
      information: [] as Array<any>,
      smartCardInfo: [] as Array<any>,
      slides: 3,
      latLongCentre: [] as Array<any>,
      markers: [] as Array<any>,
      centre: {lat: -37.840935, lng: 144.946457}, // Default center (Melbourne, Australia)
      mapZoom: 5, // Default zoom level
      mapError: null as string | null,
    }
  }

})
</script>
<style>
/* Hide swiper arrows on desktop when 3 or fewer images; keep visible on mobile */
@media (min-width: 992px) {
  #search-swipe.few-slides .swiper-button-next,
  #search-swipe.few-slides .swiper-button-prev {
    display: none !important;
  }
}

/* Required Styling */

label input[type="checkbox"] {
  display: none;
}
.custom-checkbox .fa {
  color: rgb(52, 170, 222);
  position: absolute;
  font-size: 1.5em;
}

.custom-checkbox .fa-heart-o {
  color: gray;
}

.custom-checkbox .fa-heart {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.custom-checkbox:hover .fa-heart{
  opacity: 0.5;
}

.custom-checkbox input[type="checkbox"]:checked ~ .fa-heart {
  opacity: 1;
}
.map {
  position: relative;
  width: 100%;
  height: 700px;
}
.map button, input {
  width: 100%;
}
.btn {
  border-radius:0px !important;
  height: 40px;
}
.nested-enter-active, .nested-leave-active {
  transition: all 0.3s ease-in-out;
}
/* delay leave of parent element */
.nested-leave-active {
  transition-delay: 0.25s;
}

.nested-enter-from,
.nested-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

/* we can also transition nested elements using nested selectors */
.nested-enter-active .inner,
.nested-leave-active .inner {
  transition: all 0.3s ease-in-out;
}
/* delay enter of nested element */
.nested-enter-active .inner {
  transition-delay: 0.25s;
}

.nested-enter-from .inner,
.nested-leave-to .inner {
  transform: translateX(30px);
  opacity: 0.001;
}

/* Planner card info area height (matches app.css #itenary-info). */
#itenary-info {
  min-height: 220px;
}

/* Category icons row: flex, icons + Save + heart aligned, heart pushed right */
#itenary-info .category-icons-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 0.6rem;
}

#itenary-info .category-icons-row img {
  position: static !important;
  display: inline-block;
  vertical-align: middle;
  width: 21px !important;
  height: auto !important;
  margin: 0 !important;
  padding: 0 !important;
}

#itenary-info .planner-save-label {
  color: #34aade;
  font-size: 13px;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
  margin-left: auto;
}

#itenary-info .planner-heart.custom-checkbox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  float: none !important;
  clear: none;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  border: 2px solid #34aade;
  padding: 0;
  margin: 0 !important;
  flex-shrink: 0;
}

#itenary-info .planner-heart.custom-checkbox .fa {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  color: #34aade;
}

#itenary-info .planner-heart.custom-checkbox .fa-heart-o {
  color: #34aade;
  -webkit-text-stroke: 0.5px #34aade;
}
</style>